import { takeEvery, put, takeLatest } from "redux-saga/effects";
import api from "../../services/api";
import { ENDPOINT } from "../../services/apiUrls";
import {
  getDiscountsData,
  saveDiscountsData,
  getSingleDiscountData,
  deleteSingleDiscount,
  addDiscount,
  saveChargesData,
  getAllChargesData,
  deleteSingleCharge,
  addCharge,
  getAllDiscounts,
  saveAllDiscounts,
} from "../slices";
import { toastError, toastSuccess } from "../../utils/react-toaster";

export interface ResponseGenerator {
  config?: any;
  data?: any;
  headers?: any;
  request?: any;
  status?: number;
  statusText?: string;
  success?: boolean;
  code?: any;
  results?: any;
  productvo?: any;
}

function* fetchDiscountsData(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.CHARGES_AND_DISCOUNTS.getDiscountsApi,
      data: actions.payload.dataToPost,
    });
    if (response) {
      yield put(saveDiscountsData(response));
    }
  } catch (error) {
    console.log(error);
  }
}

function* fetchSingleDiscountData(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.CHARGES_AND_DISCOUNTS.getSingleDiscountDataApi(
        actions.payload.discountId
      ),
    });
    if (response) {
      actions.payload.callback && actions.payload.callback(response);
    }
  } catch (error) {
    console.log(error);
  }
}

function* deleteDiscount(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `DELETE`,
      url: ENDPOINT.CHARGES_AND_DISCOUNTS.deleteSingleDiscountApi(
        actions.payload.discountId
      ),
    });
    actions.payload.callback(true);
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  }
}

function* addDiscountData(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.CHARGES_AND_DISCOUNTS.saveDiscountApi,
      data: actions.payload.dataToPost,
    });
    if (!response?.code) actions.payload.callback(true);
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  }
}

function* fetchAllChargesData(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.CHARGES_AND_DISCOUNTS.getAllChargesApi,
    });
    if (response) {
      yield put(saveChargesData(response));
    }
  } catch (error) {
    console.log(error);
  }
}

function* deleteCharge(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `DELETE`,
      url: ENDPOINT.CHARGES_AND_DISCOUNTS.deleteChargeApi(actions.payload.mid),
    });
    if (response.code) {
      toastError(response.code);
      actions.payload.callback(false);
    } else {
      actions.payload.callback(true);
    }
  } catch (error) {
    actions.payload.callback(false);
    console.log(error);
  }
}

function* addChargeData(actions: any) {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `POST`,
      url: ENDPOINT.CHARGES_AND_DISCOUNTS.saveChargeApi,
      data: actions.payload.dataToPost,
    });
    if (!response?.code) {
      actions.payload.callback(response);
    }
  } catch (error) {
    // actions.payload.callback(false);
    console.log(error);
  }
}

function* fetchAllDiscounts() {
  try {
    const response: ResponseGenerator = yield api.request({
      method: `GET`,
      url: ENDPOINT.CHARGES_AND_DISCOUNTS.getAllDiscounts(),
    });
    if (response) {
      yield put(saveAllDiscounts(response));
    }
  } catch (error) {
    console.log(error);
  }
}

export default function* root() {
  yield takeLatest(getAllDiscounts.type, fetchAllDiscounts);
  yield takeEvery(getDiscountsData.type, fetchDiscountsData);
  yield takeEvery(getSingleDiscountData.type, fetchSingleDiscountData);
  yield takeEvery(deleteSingleDiscount.type, deleteDiscount);
  yield takeEvery(addDiscount.type, addDiscountData);
  yield takeEvery(addCharge.type, addChargeData);
  yield takeEvery(getAllChargesData.type, fetchAllChargesData);
  yield takeEvery(deleteSingleCharge.type, deleteCharge);
}
